"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParallelGatewayViewModel = void 0;
const GatewayBaseViewModel_1 = require("./GatewayBaseViewModel");
class ParallelGatewayViewModel extends GatewayBaseViewModel_1.GatewayViewModel {
}
exports.ParallelGatewayViewModel = ParallelGatewayViewModel;
//# sourceMappingURL=ParallelGatewayViewModel.js.map